/*
 * Copyright 2026 Sony Corporation
 */

import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import VideocamIcon from '@mui/icons-material/Videocam';
import ViewInArIcon from '@mui/icons-material/ViewInAr';

export type ActivityView = 'scene' | 'devices' | 'deploy';

/**
 * The app's left edge, in one place.
 *
 * Both authoring screens render the same rail, so its contents are defined
 * once: two lists that were meant to match would eventually stop matching.
 */
export const ACTIVITY_ITEMS: { id: ActivityView; label: string; icon: React.ReactNode }[] = [
  { id: 'scene', label: 'Scene', icon: <ViewInArIcon /> },
  { id: 'devices', label: 'Devices', icon: <VideocamIcon /> },
  // What it takes to build this world for real: parts, settings, poses, gateway.
  { id: 'deploy', label: 'Deploy', icon: <RocketLaunchIcon /> },
];
